module.exports = __webpack_public_path__ + "img/a22.05ded611.svg";